import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import SortOutlinedIcon from "@mui/icons-material/SortOutlined";
import { EcocyntectLogo, EcocyntectLogoMobile } from "../assets/svgs/icon";
import { motion, AnimatePresence } from "framer-motion";

const navLinks = [
  { name: "Home", to: "/" },
  { name: "About Us", to: "/aboutUs" },
  { name: "Services", to: "/services" },
  // { name: "Projects", to: "/projects" },
  { name: "Contact", to: "/contact" },
];

const NavbarNew = () => {
  const [open, setOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024); // lg breakpoint
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 120, damping: 15 }}
      className="w-full fixed top-0 left-0 z-50 backdrop-blur-lg bg-white/40"
    >
      <div className="max-w-[1400px] mx-auto px-2 md:px-10 py-2 md:py-2 flex items-center justify-between">
        {/* LOGO LEFT */}
        <Link to="/" className="flex items-center gap-2">
          {isMobile ? <EcocyntectLogoMobile /> : <EcocyntectLogo />}
        </Link>

        {/* NAV LINKS CENTER (Desktop) */}
        <div className="hidden lg:flex items-center gap-10 mx-auto">
          {navLinks.map((link) => (
            <NavLink
              key={link.name}
              to={link.to}
              onClick={() => window.scroll(0, 0)}
              className={({ isActive }) =>
                `font-medium transition ${
                  isActive
                    ? "text-primaryColor"
                    : "text-gray-700 hover:text-primaryColor"
                }`
              }
            >
              {link.name}
            </NavLink>
          ))}
        </div>

        {/* ICONS RIGHT */}
        <div className="hidden lg:flex items-center gap-4">
          {/* <SearchIcon className="text-primaryColor text-3xl cursor-pointer" /> */}
          <SortOutlinedIcon className="text-primaryColor text-3xl cursor-pointer" />
        </div>

        {/* MOBILE MENU TOGGLE */}
        <button
          className="flex lg:hidden text-primaryColor"
          onClick={() => setOpen(!open)}
        >
          {open ? (
            <CloseIcon className="text-4xl" />
          ) : (
            <MenuIcon className="text-4xl" />
          )}
        </button>
      </div>

      {/* MOBILE MENU */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ y: -200, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -200, opacity: 0 }}
            transition={{ type: "spring", damping: 18 }}
            className="lg:hidden w-full h-screen bg-white backdrop-blur-xl shadow-sm absolute left-0 z-40 p-8 flex flex-col justify-center items-center gap-8"
          >
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-xl font-semibold ${
                    isActive
                      ? "text-primaryColor"
                      : "text-gray-800 hover:text-primaryColor"
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}

            <div className="flex items-center gap-6 mt-6">
              <SearchIcon className="text-primaryColor text-3xl" />
              <SortOutlinedIcon className="text-primaryColor text-3xl" />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default NavbarNew;
